import { activity } from '../../../app/activity'

/** One cancellable quiet slice. No continuing rAF/timer after it has run. */
export function atIdle(work: () => void, quiet = 650): () => void {
  let timer = 0, idle = 0, disposed = false
  const idleWindow = window as Window & { requestIdleCallback?: (cb: () => void, options?: { timeout: number }) => number; cancelIdleCallback?: (id: number) => void }
  const cancel = () => { clearTimeout(timer); if (idle) { if (idleWindow.cancelIdleCallback) idleWindow.cancelIdleCallback(idle); else clearTimeout(idle) }; idle = 0 }
  const quietNow = () => { const state = activity.getSnapshot(); return !document.hidden && !state.interacting && !state.scrolling && !state.sheetOpen }
  const run = () => {
    idle = 0
    if (disposed) return
    if (!quietNow()) return // Activity/visibility events re-arm; held input has no polling loop.
    if (performance.now() - activity.lastResizeAt < 900) { schedule(); return }
    dispose(); work()
  }
  // Short stages queued after an async decode must respect the same resize burst as existing work.
  const schedule = () => { cancel(); if (!disposed && quietNow()) timer = window.setTimeout(() => { idle = idleWindow.requestIdleCallback ? idleWindow.requestIdleCallback(run, { timeout: 800 }) : window.setTimeout(run, 0) }, Math.max(quiet, 900 - (performance.now() - activity.lastResizeAt))) }
  const events = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'] as const
  const dispose = () => { disposed = true; cancel(); off(); events.forEach(e => document.removeEventListener(e, schedule, true)); document.removeEventListener('visibilitychange', schedule); window.removeEventListener('resize', schedule) }
  const off = activity.subscribe(schedule)
  events.forEach(e => document.addEventListener(e, schedule, { capture: true, passive: true }))
  document.addEventListener('visibilitychange', schedule)
  window.addEventListener('resize', schedule, { passive: true })
  schedule()
  return dispose
}
